// @flow
import * as React from 'react'
import styled from 'styled-components'
import Theme from 'ui/theme'

export type Size = 'small' | 'medium' | 'large'

type Props = {
  active: boolean,
  onClick: () => void,
  size?: Size,
}

function getSize(size?: Size) {
  switch (size) {
    case 'small':
      return '80px'
    case 'medium':
      return '130px'
    case 'large':
      return '200px'
    default:
      return '80px'
  }
}

const BlockListItem: React.ComponentType<Props> = styled.li`
  display: inline-block;
  cursor: pointer;
  min-width: ${(props: Props) => getSize(props.size)};
  text-align: center;
  margin-top: ${Theme.spacing.small};
  padding: ${Theme.spacing.small};

  border: 1px solid
    ${(props: Props) =>
      props.active ? Theme.color.borderPrimary : Theme.color.borderSecondary};

  background-color: ${(props: Props) =>
    props.active ? Theme.color.main : 'initial'};

  &:hover {
    background-color: ${(props: Props) =>
      props.active ? Theme.color.main : Theme.color.mainHover};
  }
`

export default BlockListItem
